import { FONT } from "constants/fontConstants";
import { NEUTRAL_COLORS, PRIMARY_COLORS, STATUS_COLORS } from "constants/styleConstants";
import styled from "styled-components";

export const SuccessfulContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    
    width: 100%;
    height: 100%; /* Fill available space */
    overflow-y: auto; /* Enable internal scrolling */
    flex: 1; /* Grow if in a flex container */

    max-width: 1200px;
    margin: 0 auto;
    padding: 16px;
    padding-bottom: 40px; /* Ensure some space at bottom */
    box-sizing: border-box;

    h1{
        ${FONT.HEADLINES.H5}
        margin-top: 16px;
        margin-bottom: 8px;
        text-align: center;
    }
    p{
        ${FONT.BODY.BODY_SMALL[400]}
        text-align: center;
        margin-bottom: 24px;
    }

    svg {
        width: 64px;
        height: 64px;
    }


`;

export const InfoContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    margin-top: 8px;
    align-items: stretch;
    max-width: 500px;

`;

export const InfoSection = styled.div`
    display: flex;
    flex-direction: column;
    padding: 16px;
    background: ${NEUTRAL_COLORS.WHITE};
    border: 1px solid ${NEUTRAL_COLORS.LIGHT_GRAY};
    border-radius: 12px;
    gap: 8px;
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.05);

    h3 {
        ${FONT.BODY.BODY_LARGE[600]}
        color: ${NEUTRAL_COLORS.DARK};
        margin-bottom: 4px;
        font-size: 16px; 
    }

    p {
        ${FONT.BODY.BODY_SMALL[400]}
        color: ${NEUTRAL_COLORS.DARK_GRAY};
        white-space: pre-line;
        margin: 0;
        text-align: left;
        font-size: 13px;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
        
        li {
            ${FONT.BODY.BODY_SMALL[400]}
            color: ${NEUTRAL_COLORS.DARK};
            margin-bottom: 4px;
            display: flex;
            align-items: center;
            font-size: 13px;

            &:before {
                content: "•";
                margin-right: 6px;
                color: ${PRIMARY_COLORS.MEDIUM};
                font-weight: bold;
                line-height: 1;
            }
        }
    }

    a {
        ${FONT.BODY.BODY_SMALL[600]}
        color: ${PRIMARY_COLORS.MEDIUM};
        text-decoration: none;
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 14px;
        
        &:hover {
            opacity: 0.8;
            text-decoration: underline;
        }
    }
`;

export const EmailSection = styled(InfoSection)`
    border-top: 3px solid ${PRIMARY_COLORS.MEDIUM};
`;

export const WhatsappSection = styled(InfoSection)`
    border-top: 3px solid ${STATUS_COLORS.SUCCESS};
`;

export const EmergencySection = styled(InfoSection)`
    border-top: 3px solid ${STATUS_COLORS.ERROR};
    
    h3 {
        color: ${STATUS_COLORS.ERROR};
    }
`;


export const ImportantNote = styled.span`
    display: block;
    ${FONT.BODY.BODY_SMALL[600]};
    color: ${NEUTRAL_COLORS.DARK};
    font-size: 12px;
    margin-top: 8px;
    padding: 8px;
    background-color: ${NEUTRAL_COLORS.LIGHT_GRAY};
    border-radius: 4px;
`;
